import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';

import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';

import { AuthService } from '@auth/services';

@Component({
  selector: 'z-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccessDeniedComponent {
  details$ = new BehaviorSubject<boolean>(false);

  constructor(public authService: AuthService, private router: Router) {}

  moreInfo(display: boolean) {
    this.details$.next(display);
  }

  goBack() {
    this.authService.screens$.pipe(take(1)).subscribe((screens) => {
      void this.router.navigate([screens?.currentScreen?.route ?? 'home']);
    });
  }

  goHome() {
    void this.router.navigate(['home']);
  }
}
